import { render, staticRenderFns } from "./view.html?vue&type=template&id=4a613fa2&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=4a613fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a613fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a613fa2')) {
      api.createRecord('4a613fa2', component.options)
    } else {
      api.reload('4a613fa2', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=4a613fa2&scoped=true&", function () {
      api.rerender('4a613fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/custom_block_title/index.vue"
export default component.exports